import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.761 11.607a3.99 3.99 0 0 1-3.148 1.726C7.833 13.333 6.29 12 5.627 10h3.68a.663.663 0 0 0 .664-.667.67.67 0 0 0-.664-.666H5.355c0-.22-.034-.447-.034-.667s0-.447.034-.667h3.952a.663.663 0 0 0 .664-.666A.67.67 0 0 0 9.307 6H5.634c.664-2 2.198-3.333 3.985-3.333a3.98 3.98 0 0 1 3.142 1.726.665.665 0 0 0 .969.202.666.666 0 0 0 .094-.988 5.27 5.27 0 0 0-4.211-2.274c-2.498 0-4.65 1.894-5.361 4.667H2.664A.663.663 0 0 0 2 6.667a.67.67 0 0 0 .664.666h1.362v1.334H2.664A.663.663 0 0 0 2 9.333a.67.67 0 0 0 .664.667h1.588c.724 2.773 2.863 4.667 5.36 4.667a5.25 5.25 0 0 0 4.212-2.274.669.669 0 0 0-.637-.998.66.66 0 0 0-.426.212"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })